import { render } from "./SideNavChild.vue?vue&type=template&id=7c2e315b"
import script from "./SideNavChild.vue?vue&type=script&lang=js"
export * from "./SideNavChild.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__